import { __awaiter, __generator } from "tslib";
import { FirstRunType, } from '@office-start/first-run-types';
export function generateSlideGroups(workload, firstRunType, locStrings, surfaceContentEnabled, userGreetingName, companyDisplayName, isSecondRun) {
    if (userGreetingName === void 0) { userGreetingName = ''; }
    if (companyDisplayName === void 0) { companyDisplayName = ''; }
    return __awaiter(this, void 0, void 0, function () {
        var _a, exhaustiveCheck;
        var _this = this;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = firstRunType;
                    switch (_a) {
                        case FirstRunType.ConsumerFree: return [3 /*break*/, 1];
                        case FirstRunType.ConsumerFreeUpsellDisabled: return [3 /*break*/, 3];
                        case FirstRunType.ConsumerPaidIndividual: return [3 /*break*/, 5];
                        case FirstRunType.ConsumerPaidFamily: return [3 /*break*/, 7];
                        case FirstRunType.CommercialStandardUser: return [3 /*break*/, 9];
                        case FirstRunType.CommercialItAdmin: return [3 /*break*/, 11];
                        case FirstRunType.EduStudent: return [3 /*break*/, 13];
                        case FirstRunType.EduFaculty: return [3 /*break*/, 15];
                        case FirstRunType.EduItAdmin: return [3 /*break*/, 17];
                    }
                    return [3 /*break*/, 19];
                case 1: return [4 /*yield*/, import('../slideGroups/generateConsumerFreeSlideGroups').then(function (mod) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, mod.generateConsumerFreeSlideGroups(workload, locStrings, surfaceContentEnabled, userGreetingName, false, isSecondRun)];
                                case 1: return [2 /*return*/, _a.sent()];
                            }
                        });
                    }); })];
                case 2: return [2 /*return*/, _b.sent()];
                case 3: return [4 /*yield*/, import('../slideGroups/generateConsumerFreeSlideGroups').then(function (mod) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, mod.generateConsumerFreeSlideGroups(workload, locStrings, surfaceContentEnabled, userGreetingName, true, isSecondRun)];
                                case 1: return [2 /*return*/, _a.sent()];
                            }
                        });
                    }); })];
                case 4: return [2 /*return*/, _b.sent()];
                case 5: return [4 /*yield*/, import('../slideGroups/generateConsumerPaidIndividualSlideGroups').then(function (mod) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, mod.generateConsumerPaidIndividualSlideGroups(locStrings, surfaceContentEnabled, userGreetingName, isSecondRun)];
                                case 1: return [2 /*return*/, _a.sent()];
                            }
                        });
                    }); })];
                case 6: return [2 /*return*/, _b.sent()];
                case 7: return [4 /*yield*/, import('../slideGroups/generateConsumerPaidFamilySlideGroups').then(function (mod) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, mod.generateConsumerPaidFamilySlideGroups(locStrings, surfaceContentEnabled, userGreetingName, isSecondRun)];
                                case 1: return [2 /*return*/, _a.sent()];
                            }
                        });
                    }); })];
                case 8: return [2 /*return*/, _b.sent()];
                case 9: return [4 /*yield*/, import('../slideGroups/generateCommercialStandardUserSlideGroups').then(function (mod) {
                        return mod.generateCommercialStandardUserSlideGroups(locStrings, userGreetingName, companyDisplayName);
                    })];
                case 10: return [2 /*return*/, _b.sent()];
                case 11: return [4 /*yield*/, import('../slideGroups/generateCommercialItAdminSlideGroups').then(function (mod) {
                        return mod.generateCommercialItAdminSlideGroups(locStrings, userGreetingName);
                    })];
                case 12: return [2 /*return*/, _b.sent()];
                case 13: return [4 /*yield*/, import('../slideGroups/generateEduStudentSlideGroups').then(function (mod) {
                        return mod.generateEduStudentSlideGroups(locStrings, userGreetingName);
                    })];
                case 14: return [2 /*return*/, _b.sent()];
                case 15: return [4 /*yield*/, import('../slideGroups/generateEduFacultySlideGroups').then(function (mod) {
                        return mod.generateEduFacultySlideGroups(locStrings, userGreetingName);
                    })];
                case 16: return [2 /*return*/, _b.sent()];
                case 17: return [4 /*yield*/, import('../slideGroups/generateEduItAdminSlideGroups').then(function (mod) {
                        return mod.generateEduItAdminSlideGroups(locStrings, userGreetingName);
                    })];
                case 18: return [2 /*return*/, _b.sent()];
                case 19:
                    exhaustiveCheck = firstRunType;
                    throw new Error(exhaustiveCheck);
            }
        });
    });
}
//# sourceMappingURL=generateSlideGroups.js.map